import React from 'react';
import PropTypes from 'prop-types';
import sizes from './sizes';
import { Pencil } from 'lucide-react';
import CircleButton from './CircleButton';
const EditButton = ({ disabled, onClick, title, id, dataTestId }) => {
    return (React.createElement(CircleButton, { id: id, disabled: disabled, onClick: onClick, title: title, dataTestId: dataTestId || 'editButton', color: "blue" },
        React.createElement(Pencil, { className: "w-4 h-4" })));
};
EditButton.propTypes = {
    id: PropTypes.string,
    size: PropTypes.oneOf(Object.values(sizes)),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    title: PropTypes.string,
};
EditButton.defaultProps = {
    size: sizes.normal,
    disabled: false,
    title: '',
    onClick: () => { },
};
export default EditButton;
